import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, first, takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { DealAnalysisService } from 'src/app/_shared/service/deal-analysis.service';
import { ImageGalleryState } from 'src/app/_shared/state/image-gallery.state';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { CmaService } from 'src/app/cma/cma.service';
import { ConfirmDialogComponent } from 'src/app/shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { SubscriptionPlanService } from 'src/app/shared/service/subscription-plan.service';
import { PropertyState } from 'src/app/workspace/state/property.state';
import constants from 'src/constant.json';
import { LoanComputationService } from '../../service/loan-computation.service';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';
import { CreateMortgageDialogComponent } from '../create-mortgage-dialog/create-mortgage-dialog.component';
import { CreateMyHomeDialogueComponent } from '../create-my-home-dialogue/create-my-home-dialogue.component';

interface address {
  streetAddress: string;
  fullAddress: string;
  city: string;
  state: string;
  zip: string;
  propertySubType: string;
  bedCount: number;
  bathCount: number;
  livingAreaSize: number;
  lotSize: number;
  coordinate: Object;
  PMXPropertyId: number | string;
  id: string;
  streetName: string;
  streetNumber: string;
  propertyType: string;
  purchaseDate: string;
}

@Component({
  selector: 'app-my-home',
  templateUrl: './my-home.component.html',
  styleUrls: ['./my-home.component.scss'],
})
export class MyHomeComponent implements OnInit, OnDestroy {
  @ViewChild('mortgageSectionToScroll') mortgageSectionToScroll: ElementRef;
  @ViewChild('equitySectionToScroll') equitySectionToScroll: ElementRef;
  isSavedDealsLoading: any;
  savedDealData: any;
  myHomeDealsList$ = this.myHomeState.myHomeDealsList$;
  DealsList: any;
  savedDealList: any;
  cmaReports: any;
  userId: any;
  pmxPropertyId: any;

  constructor(
    private myHomeService: MyHomeService,
    private authorizeService: AuthorizeService,
    public myHomeState: MyHomeState,
    private loanService: LoanComputationService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public appState: AppState,
    private cdr: ChangeDetectorRef,
    private userState: UserState,
    private dealAnalysisService: DealAnalysisService,
    public imageGalleryState: ImageGalleryState,
    private propertyState: PropertyState,
    public cmaService: CmaService,
    private subscriptionService: SubscriptionPlanService,

  ) { }

  homeList = [];
  mortgageArray: any;
  selectedPmxId;
  activeHome$;
  activeHome;
  address: address;
  initialValue: number;
  currentValue: number;
  propmixValue: number;
  loanBalance: number;
  netEquity: number;
  appreciateRatio: number;
  purchaseValue: number;
  isLoading = false;
  spendForecastSheetActive: boolean = false;
  selectedRouteId: string;
  selectedHomeValue: any;
  activePropertyDetails: any = {};
  propertyAddedParams: any;
  newMyProperty: boolean = false;
  propertyDetailsEnabled: boolean = false;
  maintenanceEnabled: boolean = false;
  financingEnabled: boolean = false;
  rentalAnalysisEnabled: boolean = false;
  selectedTabIndex = 0;
  previousPmxId: any;
  isGalleryOpen: boolean = false;
  myHomeLoaded: boolean = false;
  tabIndex = 0;

  // Subject used to unsubscribe all Subscriptions on OnDestroy
  private onDestroyNotifier: Subject<any> = new Subject<any>();
  ngOnInit() {
    this.userState.userDetail$
      .pipe(
        takeUntil(this.onDestroyNotifier),
        filter((res) => res !== null),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)), // Only emit when the value changes
        first() // Take only the first valid change and then complete
      )
      .subscribe((res) => {
        if (res) {
          this.userId = res?.id;
        }

        if (res && !this.myHomeLoaded) {
          if (this.authorizeService.canAct('myHome')) {
            this.loadMyHome();
          }
        }

      });
    const tab = this.activatedRoute.snapshot.queryParamMap.get('tab');
    if (tab === 'finance' && !this.userId || !this.userId) {
      this.getHomeList();

    }
  }

  loadMyHome() {
    this.myHomeLoaded = true;
    this.newMyProperty = this.appState.companyInfoValue.appConfig?.myProperty?.isEnabled || false;
    this.propertyDetailsEnabled = this.appState.companyInfoValue.appConfig?.myProperty?.propertyDetailsEnabled || false;
    this.maintenanceEnabled = this.appState.companyInfoValue.appConfig?.myProperty?.maintenanceEnabled || false;
    this.financingEnabled = this.appState.companyInfoValue.appConfig?.myProperty?.financingEnabled || false;
    this.rentalAnalysisEnabled = this.appState.companyInfoValue.appConfig?.myProperty?.rentalAnalysisEnabled || false;


    this.getHomeList();

    this.activatedRoute.queryParams.pipe().subscribe((res) => {
      if (res.street && res.city) {
        this.propertyAddedParams = res.city || res.state;
        this.selectedRouteId = null;
      }
      if (res.id) {
        this.selectedRouteId = res.id;
        this.propertyAddedParams = null;
      }
    });

    this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((mortgageHistory) => {
      this.mortgageArray = [].concat(mortgageHistory);
      let loanAmount = 0;
      if (mortgageHistory && mortgageHistory.length) {
        mortgageHistory.map((element) => {
          element.PMXPropertyId = this.myHomeState.activeHomeValue.PMXPropertyId;
          let computedLoan = this.loanService.computeTotalLoan(
            element.principal,
            element.interest / 100,
            element.term,
            new Date(element.startDate)
          );

          if (computedLoan && computedLoan.principalBalance && isFinite(computedLoan.principalBalance)) {
            loanAmount = loanAmount + computedLoan.principalBalance;
          }
        });
      }
      this.loanBalance = JSON.parse(JSON.stringify(loanAmount));
      this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
    });

    this.myHomeState.myHomeList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((homeList) => {
      if (!homeList || !homeList.length) return;
      if (!this.selectedRouteId && this.selectedRouteId != 'undefined' && this.propertyAddedParams == null) {
        this.router.navigate(['/my-property'], {
          relativeTo: this.activatedRoute,
          queryParams: {
            id: homeList[0].id,
          },
          queryParamsHandling: 'merge',
        });
        this.selectedRouteId = homeList[0].id;
      }

      if (this.propertyAddedParams) this.selectedRouteId = homeList[0].id;
      this.selectedHomeValue = homeList.find((selectedHome) => selectedHome.id == this.selectedRouteId);
      this.homeList = homeList;
      if (this.myHomeState.activeHomeValue && !this.myHomeState.activeHomeValue.id) {
        this.myHomeState.mortgageListValue = this.selectedHomeValue?.mortgageList
          ? this.selectedHomeValue.mortgageList
          : [];
        this.myHomeState.activeHomeValue = this.selectedHomeValue;
      } else {
        let home = this.homeList.find(
          (home) => home?.PMXPropertyId && home?.PMXPropertyId == this.myHomeState?.activeHomeValue?.PMXPropertyId
        );
        if (home) {
          this.myHomeState.mortgageListValue = home.mortgageList;
          this.myHomeState.activeHomeValue = home;
        }
      }
      this.activeHomeChanged();
      this.getSavedDeals();
    });
    this.myHomeState.activeHomeValues$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((response) => {
      if (response && response.length && this.activeHome && this.activeHome.PMXPropertyId) {
        this.propertyValuesChanged();
      }
    });

    this.myHomeState.openSpendForecastSheet$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((status) => {
      this.spendForecastSheetActive = status;
    });
    // Subscribe to URL Query Params and trigger Add Property if address components exists
    this.activatedRoute.queryParams.pipe(takeUntil(this.onDestroyNotifier)).subscribe((res) => {
      if (res && res.street && res.city && res.state && res.zip) this.openAppPropertyDialog(res);
    });

    this.imageGalleryState.imgGalleryList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((res) => {
      if (
        Object.keys(this.propertyState.activePropertyDetailsValue).length == 0 ||
        !this.propertyState.activePropertyDetailsValue
      ) {
        if (res && res.length > 0) {
          this.isGalleryOpen = true;
        } else {
          this.isGalleryOpen = false;
        }
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      const tabKey = params['tab'];
      if (this.maintenanceEnabled && this.propertyDetailsEnabled && tabKey == 'finance') {
        this.tabIndex = 2;
      } else if (tabKey == 'finance' && !this.maintenanceEnabled && this.propertyDetailsEnabled) {
        this.tabIndex = 1;
      } else if (this.maintenanceEnabled && !this.propertyDetailsEnabled && tabKey == 'finance') {
        this.tabIndex = 1;
      }

    });

  }

  closeGallery(): void {
    this.imageGalleryState.imgGalleryListValue = null;
    this.isGalleryOpen = false;
  }

  onSectionScrolled(event: Event) {
    this.mortgageSectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  equitySectionScrolled(event: Event) {
    this.equitySectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  currentValueEdited(value) {
    if (!this.propmixValue) this.netEquity = Number(value) - this.loanBalance;
  }

  propmixValueEdited(value) {
    this.netEquity = Number(value) - this.loanBalance;
    this.appreciateRatio =
      Number(value) && Number(this.purchaseValue)
        ? ((Number(value) - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
  }

  purchaseValueEdited(value) {
    this.appreciateRatio =
      Number(this.propmixValue) && Number(this.purchaseValue)
        ? ((this.propmixValue - Number(value)) / Number(value)) * 100
        : 0;
  }

  propertyValuesChanged() {
    let propertyValues = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.activeHome.PMXPropertyId
    );
    this.propmixValue =
      this.activeHome && Number(this.activeHome.customPropmixValue)
        ? this.activeHome.customPropmixValue
        : propertyValues && propertyValues.propmixValue
          ? propertyValues.propmixValue
          : 0;
    this.currentValue =
      this.activeHome && Number(this.activeHome.customCurrentValue)
        ? this.activeHome.customCurrentValue
        : propertyValues && propertyValues.currentValue
          ? propertyValues.currentValue
          : 0;
    this.purchaseValue =
      this.activeHome && Number(this.activeHome.customPurchaseValue)
        ? this.activeHome.customPurchaseValue
        : this.activeHome && this.activeHome.purchaseValue
          ? this.activeHome.purchaseValue
          : 0;
    this.appreciateRatio =
      this.propmixValue && this.purchaseValue
        ? ((this.propmixValue - this.purchaseValue) / this.purchaseValue) * 100
        : 0;
    this.netEquity = (this.propmixValue || this.currentValue) - this.loanBalance;
  }

  activeHomeChanged() {
    this.myHomeState.DealAnalysisHomeValue = {};
    let response = this.myHomeState.activeHomeValue;
    if (response && response.id) {
      this.pmxPropertyId = response.PMXPropertyId
      this.dealAnalysisService
        .getSavedDealAnalysisByAddress({ PMXPropertyId: response.PMXPropertyId })
        .pipe(takeUntil(this.onDestroyNotifier))
        .subscribe(
          (res: any) => {
            if (res && res?.savedDeals && res?.savedDeals.length) {
              this.savedDealData = res?.savedDeals[0]?.deals;
              this.myHomeState.rentalDealsListValue = this.savedDealData;
            } else {
              this.myHomeState.rentalDealsListValue = [];
            }
          },
          (error) => {
            console.log('error', error);
          }
        );

      this.myHomeState.activePropertyDetailsValue = null;
      this.myHomeService.getPropertyDetails({
        pmxPropertyId: response.PMXPropertyId,
        type: ['basic', 'avm', 'listing'],
      });
      this.activeHome = response;
      this.getPropertyValues();
      this.addressComponents(response);
    } else {
      this.address = null;
    }
    if (this.userId) {
      this.getSharedCmaReports();
    }
    this.cdr.detectChanges();
  }

  getSavedDeals() {
    this.myHomeState.myHomeDealsList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((dealList) => {
      if (!dealList) {
        this.savedDealList = [];
        return;
      }
      this.savedDealList = dealList.sort((a, b) => {
        const dateA = new Date(a.lastSavedDate).getTime();
        const dateB = new Date(b.lastSavedDate).getTime();
        return dateB - dateA;
      });
    });
  }

  addressComponents(response) {
    this.myHomeState.activePropertyDetails$.subscribe((res) => {
      if (res?.basic) {
        this.activePropertyDetails = res.basic;
        if (this.previousPmxId !== res.basic.PMXPropertyId) {
          this.previousPmxId = res.basic.PMXPropertyId;
          this.selectedTabIndex = 0;
        }
        let propertyInfo = {
          streetAddress: response.streetAddress,
          fullAddress: this.activePropertyDetails.Address,
          city: this.activePropertyDetails.City,
          state: this.activePropertyDetails.StateOrProvince,
          zip: this.activePropertyDetails.PostalCode,
          propertySubType: this.activePropertyDetails.PropertySubType,
          bedCount: this.activePropertyDetails.BedroomsTotal,
          bathCount: this.activePropertyDetails.BathroomsTotalInteger,
          livingAreaSize: this.activePropertyDetails.LivingArea,
          lotSize: this.activePropertyDetails.LotSizeSquareFeet,
          coordinate: response.coordinate,
          PMXPropertyId: this.activePropertyDetails.PMXPropertyId,
          id: response.id,
          streetName: this.activePropertyDetails.StreetName,
          streetNumber: this.activePropertyDetails.StreetNumber,
          propertyType: this.activePropertyDetails.PropertyType,
          purchaseDate: response.purchaseDate,
          customCurrentValue: response.customCurrentValue,
          customPropmixValue: response.customPropmixValue,
          customPurchaseValue: response.customPurchaseValue,
          lstListingId: this.activePropertyDetails.Lst_ListingId,
        };
        this.address = propertyInfo;
        this.cdr.detectChanges();
      }
    });
  }
  getSharedCmaReports() {

    let params = {
      userId: this.userId,
      PMXPropertyId: this.pmxPropertyId
    }
    this.cmaService.getSharedCmaReports(params).subscribe({
      next: (response) => {
        if (response.error) {
          console.error('Error getting reports', response.error);
        } else {
          if (response) {
            this.cmaReports = response.data;
          }
        }
      },
      error: (err) => console.error('Unexpected error:', err),
      complete: () => { }
    });
  }
  getPropertyValues() {
    this.myHomeState.activeHomePropertyLoaderValue = true;
    let isValueExists = this.myHomeState.activeHomePropertyValue.find(
      (prop) => prop.pmxPropertyId == this.activeHome.PMXPropertyId
    );
    if (!isValueExists) {
      let params = {
        StreetNumber: this.activeHome.streetNumber,
        StreetName: this.activeHome.streetName,
        City: this.activeHome.city,
        State: this.activeHome.state,
        Zip: this.activeHome.zip,
        pmxPropertyId: this.activeHome.PMXPropertyId,
      };
      this.myHomeService.getPropertyValues(params).subscribe(() => { });
    } else {
      this.propertyValuesChanged();
      this.myHomeState.activeHomePropertyLoaderValue = false;
    }
  }

  addRental() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        'deal-analysis-property-id': this.myHomeState.activeHomeValue.PMXPropertyId,
        rentalAnalysis: true,
      },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.next();
    this.onDestroyNotifier.complete();
    this.myHomeState.mortgageListValue = [];
    this.myHomeState.activeHomeValue = {};
    this.myHomeState.activePropertyDetailsValue = null;
  }

  getHomeList() {
    this.myHomeService
      .getHomeList()
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(({ isLoading }) => {
        this.isLoading = isLoading;
      });
  }

  updateHome() {
    this.myHomeService
      .updateMyHomeValues(this.myHomeState.myHomeListValue)
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe((res) => { });
  }

  openAppPropertyDialog(addressComponent: any) {
    if (!this.subscriptionService.checkFeatureValidity(constants.PLAN_BASED_FEATURES.addMyHome.key)) return;

    this.dialog.open(CreateMyHomeDialogueComponent, {
      width: '385px',
      disableClose: true,
      data: addressComponent,
    });
  }

  closeSpendForecastSheet() {
    this.myHomeState.openSpendForecastSheetValue = false;
  }

  deleteProperty(id) {
    let _this = this;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteMyHomeProperty',
        message: 'The selected property will be deleted from My Properties',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          if (status) {
            _this.selectedPmxId = null;
            _this.myHomeService.deleteMyHomeProperty(id).subscribe((res: any) => {
              callBack({ status: true });
              dialogRef.close();
            });
          } else {
            return false;
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });
  }
  navigateToSavedDeal(dealId, dealType) {
    if (dealId && dealType) {
      this.router.navigate(['my-property'], {
        queryParams: { 'deal-analysis-id': dealId, rentalAnalysis: true },
      });
    } else if (dealId) {
      this.router.navigate(['my-property'], {
        queryParams: { 'deal-analysis-id': dealId, rentalAnalysis: false },
      });
    }
  }

  deleteDeal(dealId, deleteBy, PMXPropertyId, dealType) {
    this.openDeleteDealDialog(dealId, deleteBy, PMXPropertyId, dealType);
  }

  openDeleteDealDialog(dealId, deleteBy, PMXPropertyId, dealType) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteDeal',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          let params: any = {
            id: dealId,
          };
          if (dealType) {
            params.type = dealType;
          }
          if (status) {
            this.dealAnalysisService
              .deleteDeal(params)
              .pipe(takeUntil(this.onDestroyNotifier))
              .subscribe((res) => {
                this.dealAnalysisService
                  .getSavedDealAnalysisByAddress({ PMXPropertyId: PMXPropertyId })
                  .pipe(takeUntil(this.onDestroyNotifier))
                  .subscribe((res: any) => {
                    if (res && res?.savedDeals && res?.savedDeals.length) {
                      this.savedDealData = res?.savedDeals[0]?.deals;
                      if (this.savedDealData.length) {
                        this.myHomeState.rentalDealsListValue = this.savedDealData;
                      } else {
                        this.myHomeState.rentalDealsListValue = [];
                      }
                    } else {
                      this.myHomeState.rentalDealsListValue = [];
                    }
                  });
              });
            callBack({ status: true });
            dialogRef.close();
          } else {
            return false;
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });
  }

  openMortgagePopup(data?) {
    this.dialog.open(CreateMortgageDialogComponent, {
      width: '385px',
      disableClose: true,
      data: {
        type: data && data.type ? data.type : 'addMortgage',
        title: data && data.title ? data.title : 'Add Mortgage',
        message: data && data.message ? data.message : 'Add missing mortgage to current property!',
        principal: data && data.principal ? data.principal : null,
        interest: data && data.interest ? data.interest : '',
        term: data && data.term ? data.term : '',
        startDate: data && data.startDate ? data.startDate : '',
        id: data && data.id ? data.id : null,
      },
    });
  }
}
